import { Property } from "csstype";
import * as React from "react";
import { Hint } from "react-ui";

import { useCandyTheme } from "../../Internals/ThemeProvider/CandyTheme/UseCandyTheme";

interface LinetextProps {
    fontSize?: string | number;
    fontWeight?: Property.FontWeight;
    lineHeight?: string | number;
    marginTop?: string | number;
    marginBottom?: string | number;
    marginLeft?: string | number;
    marginRight?: string | number;
    textAlign?: Property.TextAlign;
    width?: string | number;
    verticalAlign?: Property.VerticalAlign<string>;
    color?: string;
    hint?: string | React.ReactNode;
    children: React.ReactNode;
    "data-tid"?: string;
}

export function Linetext(props: LinetextProps): JSX.Element {
    const theme = useCandyTheme();

    const rootStyles: React.CSSProperties = {
        display: props.width == undefined ? "inline" : "inline-block",
        fontSize: props.fontSize,
        fontWeight: props.fontWeight,
        lineHeight: props.lineHeight,
        marginTop: props.marginTop,
        marginBottom: props.marginBottom,
        marginLeft: props.marginLeft,
        marginRight: props.marginRight,
        textAlign: props.textAlign,
        width: props.width,
        verticalAlign: props.verticalAlign,
    };
    const result = (
        <div style={rootStyles}>
            <span data-tid={props["data-tid"]} style={{ color: props.color ?? theme.typography.primary.color }}>
                {props.children}
            </span>
        </div>
    );
    if (props.hint != undefined) {
        return <Hint text={props.hint}>{result}</Hint>;
    } else {
        return result;
    }
}
